const LessonTheatreSteps = [
  { // step 0 - intro
    size : "ROW",
    name: "general.intro",
    description: "course.theatre.lesson-background.description",
    AnimalName : "bunny",
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_theatre_intro.jpg",
    id: "theatre_intro",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_intro_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.intro.videoURL_01",
        videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_theatre_intro.jpg",
        isStepGoal: true,
        isSkippable: true,
        notMandatory: true
      }
    ]
  },
  { // Skill
    buttonShape: "circle",
    size : "coinImg",
    name: "teamworkSkills.create-the-turn.name",
    description: "teamworkSkills.create-the-turn.description",
    todo: "teamworkSkills.create-the-turn.todo",
    coinName: "create-the-turn",
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_create-the-turn.jpg",
    id: "tempSkillForTheatre",
    legacyIds: [],
    stepItems : [
      {
        id:"theatre-recap_wheel-of-creativity",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_wheel-of-creativity-poster.jpg",
        discussTitle: "general.whoKnows",
        discussSubtitle: "teamworkSkills.wheel-of-creativity.discussSubtitle",
      },
      {
        id:"theatre_recap_stop-to-relax",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/stop-the-anger-poster.jpg",
        discussTitle: "general.whoKnows",
        discussSubtitle: "teamworkSkills.stop-to-relax.discussTitle",
      },
      {
        id:"theatre_recap_idea-behind-mistake",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/alexander-and-mistake.jpg",
        discussTitle: "general.whoKnows",
        discussSubtitle: "teamworkSkills.idea-behind-mistake.discussTitle",
      },
      {
        id: "create-the-turn_video-A",
        legacyIds: [],
        pageState: "video",
        url: "teamworkSkills.create-the-turn.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"discuss-create-the-turn_video-A",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_create-the-team.png",
        discussTitle: "teamworkSkills.create-the-turn.choose-team-title",
        discussSubtitle: "teamworkSkills.create-the-turn.choose-team-subtitle",
      },
      {
        id:"discuss-create-the-turn_glue",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_create-the-turn_glue.jpg",
        discussTitle: "teamworkSkills.create-the-turn.glue-title",
        discussSubtitle: "teamworkSkills.create-the-turn.glue-subtitle",
      },
      {
        id: "create-the-turn_video-B",
        legacyIds: [],
        pageState: "video",
        url: "teamworkSkills.create-the-turn.videoURL_02",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"discuss-create-the-turn_video-B",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_create-the-turn_1st-turn.jpg",
        discussTitle: "teamworkSkills.create-the-turn.choose-1st-turn-title",
        discussSubtitle: "teamworkSkills.create-the-turn.choose-1st-turn-subtitle",
      },
      {
        id:"discuss-create-the-turn_glue-2nd-time",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_create-the-turn_glue.jpg",
        discussTitle: "teamworkSkills.create-the-turn.glue-title",
        discussSubtitle: "teamworkSkills.create-the-turn.glue-subtitle",
      },
    ]
  },
  { // dotted-lines
    StepNumberToShow: 1,
    name: "course.theatre.lesson-theatre.steps.dotted-lines.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-theatre.steps.dotted-lines.description",
    requirements: [{name: "usedPaper"}, {name: "cardboard-piece"}, {name: "tush"} ],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/theatre_dotted-lines.jpg",
    id: "theatre_dotted-lines",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_dotted-lines_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.dotted-lines.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id: "theatre_dotted-lines_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-theatre.steps.dotted-lines.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-theatre.steps.dotted-lines.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_dotted-lines_01.jpg"
          },
          {
            text: "course.theatre.lesson-theatre.steps.dotted-lines.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_dotted-lines_02.jpg"
          }
        ],
      }
    ]
  },
  { // draw-window
    StepNumberToShow: 2,
    name: "course.theatre.lesson-theatre.steps.draw-window.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-theatre.steps.draw-window.description",
    requirements: [{name: "usedPaper"}, {name: "tush"}],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/theatre_draw-window.jpg",
    id: "theatre_draw-window",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_draw-window_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.draw-window.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id: "theatre_draw-window_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-theatre.steps.draw-window.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-theatre.steps.draw-window.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_draw-window_01.jpg"
          },
          {
            text: "course.theatre.lesson-theatre.steps.draw-window.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_draw-window_02.jpg"
          },
          {
            text: "course.theatre.lesson-theatre.steps.draw-window.bullets.bullet3",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_draw-window_03.jpg"
          }
        ],
      }
    ]
  },
  { // make-hole
    StepNumberToShow: 3,
    name: "course.theatre.lesson-theatre.steps.make-hole.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-theatre.steps.make-hole.description",
    requirements: [{name: "scissors"}, {name: "masking-tape"}],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/theatre_make-hole.jpg",
    id: "theatre_make-hole",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_make-hole_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.make-hole.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id: "theatre_make-hole_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-theatre.steps.make-hole.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-theatre.steps.make-hole.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_make-hole_01.jpg"
          },
          {
            text: "course.theatre.lesson-theatre.steps.make-hole.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_make-hole_02.jpg"
          },
          {
            text: "course.theatre.lesson-theatre.steps.make-hole.bullets.bullet3",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_make-hole_03.jpg"
          }
        ]
      }
    ]
  },
  { // cut-window
    StepNumberToShow: 4,
    name: "course.theatre.lesson-theatre.steps.cut-window.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-theatre.steps.cut-window.description",
    requirements: [{name: "scissors"}],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/theatre_cut-window.jpg",
    id: "theatre_cut-window",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_cut-window_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.cut-window.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id: "theatre_cut-window_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-theatre.steps.cut-window.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-theatre.steps.cut-window.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_cut-window_01.jpg"
          },
          {
            text: "course.theatre.lesson-theatre.steps.cut-window.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_cut-window_02.jpg"
          }
        ]
      }
    ]
  },
  { // fold-cardboard
    StepNumberToShow: 5,
    name: "course.theatre.lesson-theatre.steps.fold-cardboard.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-theatre.steps.fold-cardboard.description",
    requirements: [{name: "scissors"}],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/theatre_fold-cardboard.jpg",
    id: "theatre_fold-cardboard",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_fold-cardboard_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.fold-cardboard.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id: "theatre_fold-cardboard_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-theatre.steps.fold-cardboard.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-theatre.steps.fold-cardboard.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_fold-cardboard_01.jpg"
          },
          {
            text: "course.theatre.lesson-theatre.steps.fold-cardboard.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_fold-cardboard_02.jpg"
          }
        ]
      }
    ]
  },
  { // decorate
    StepNumberToShow: 6,
    name: "course.theatre.lesson-theatre.steps.decorate.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-theatre.steps.decorate.description",
    requirements: [{name: "scissors"}, {name: "stick-glue"} ],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/theatre_decorate.jpg",
    id: "theatre_decorate",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_decorate_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.decorate.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id: "theatre_decorate_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-theatre.steps.decorate.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-theatre.steps.decorate.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_decorate_01.jpg"
          }
        ]
      }
    ]
  },
  { // color
    StepNumberToShow: 7,
    name: "course.theatre.lesson-theatre.steps.color.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-theatre.steps.color.description",
    requirements: [{name: "allColors"}],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/theatre_color.jpg",
    id: "theatre_color",
    legacyIds: [],
    stepItems : [
      {
        id: "theatre_color_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-theatre.steps.color.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id: "theatre_color_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-theatre.steps.color.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/theatre_color_01.jpg"
          }
        ]
      }
    ]
  },
  { // piano fight
    name: "conflict-simulator.piano-fight.name",
    size : "CUSTOM-IMG",
    state: "disabled",
    description: "conflict-simulator.piano-fight.description",
    taskTitle: "conflict-simulator.piano-fight.taskTitle",
    taskSubTitle: "conflict-simulator.piano-fight.taskSubTitle",
    ImageToShow: "/assets/course/theatre/videos-and-thumbnails/croc-angry.png",
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/step2-thumbnail.jpg",
    id:"piano-fight",
    legacyIds: [],
    stepItems : [
      {
        id:"piano-fight_let-dry",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/let-dry.jpg",
        discussTitle: "let-dry.title",
        discussSubtitle: "let-dry.description"
      },
      {
        id:"piano-fight_video-part-one",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.piano-fight.videoURL_01",
        videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/step2-thumbnail.jpg",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"piano-fight_q1",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/step2-thumbnail.jpg",
        discussTitle: "conflict-simulator.piano-fight.q1-title",
      },
      {
        id:"piano-fight_q2",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/step2-thumbnail.jpg",
        discussTitle: "conflict-simulator.piano-fight.q2-title",
      },
      {
        id:"piano-fight_conflict-simulator",
        legacyIds: [],
        pageState: "needCards",
        thumbnailUrl: "https://media.catbears.com/course_theatre/piano-fight_what-he-needs.png",
        backgoundColor: "#43af4c",
        cards: ["Love", "friendship","Idea" ]
      },
      {
        id:"piano-fight_video-part-two",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.piano-fight.videoURL_02",
        videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/step2-thumbnail.jpg",
        isStepGoal: true,
        isSkippable: true
      },
    ]
  },
  { // trophy
    name: "finishStep.name",
    size : "CUSTOM-IMG",
    state: "disabled",
    ImageToShow: "/assets/icons/icon_trophy.svg",
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/trophy-thumbnail.png",
    id:"theatre_trophy",
    legacyIds: [],
    stepItems : [
      {
        id:"theatre_recap_trophy_discuss",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_create-the-turn.jpg",
        discussTitle: "general.whoKnows",
        discussSubtitle: "teamworkSkills.create-the-turn.discussTitle",
      },
      {
        id:"theatre_trophy_cleanup",
        legacyIds: ["background_trophy_cleanup"],
        pageState: "discuss",
        img: "/assets/course/theatre/theatre_cleanup.png",
        discussTitle: "cleanup.title",
        discussSubtitle: "cleanup.description"
      },
      {
        id:"dance_theatre_video",
        legacyIds: ["dance_background_video"],
        pageState: "video",
        url: "finishStep.videoURL_01",
        isSkippable: true,
        isStepGoal: true
      },
    ]
  }
]

export default LessonTheatreSteps;
